import { Heading } from "@amzn/meridian";
import Tab, { TabGroup } from "@amzn/meridian/tab";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { isBetaOrLocalEnv } from "src/utils/detectEnv";
import "./admin.scss";
import "./adminReport/adminReport.scss";

const ADMIN_TABS = [
  { path: "/admin/overview", label: "Overview" },
  { path: "/admin/documents", label: "Current Documents" },
  { path: "/admin/failures", label: "Failed Test Cases" },
  { path: "/admin/conversations", label: "Conversation List" },
];

const Admin = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Gamma and prod keep the original single-view Conversation List page. The
  // tabbed Admin Report ships to beta only until it is signed off there.
  if (!isBetaOrLocalEnv()) {
    return (
      <div className="admin">
        <Heading level={1}>Admin</Heading>
        <Outlet />
      </div>
    );
  }

  // No fallback: a path outside the tabs, such as the legacy
  // /admin/:conversationId link, highlights nothing rather than wrongly
  // lighting up Overview while another view is on screen.
  const selectedTab =
    ADMIN_TABS.find(({ path }) => pathname.startsWith(path))?.path ?? "";

  return (
    <div className="admin">
      <Heading level={1}>Admin Report</Heading>
      <div className="admin__tabs">
        <TabGroup
          value={selectedTab}
          onChange={(path) => navigate(path)}
          fill="line"
        >
          {ADMIN_TABS.map(({ path, label }) => (
            <Tab key={path} value={path}>
              {label}
            </Tab>
          ))}
        </TabGroup>
      </div>
      <Outlet />
    </div>
  );
};

export default Admin;
